<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
//禁止手机缩放
window.onload = function () {
  document.addEventListener('touchstart', function (event) {
    if (event.touches.length > 1) {
      event.preventDefault()
    }
  })
  var lastTouchEnd = 0
  document.addEventListener(
    'touchend',
    function (event) {
      var now = new Date().getTime()
      if (now - lastTouchEnd <= 300) {
        event.preventDefault()
      }
      lastTouchEnd = now
    },
    false
  )
  document.addEventListener('gesturestart', function (event) {
    event.preventDefault()
  })
}

export default {
  name: 'App'
}
</script>

<style>
@import './assets/css/font.css';
@import './operationViews/style/common.css';

body {
  margin: 0px;
  font-family: 'PingFang SC';
}
#app {
  margin: 0px auto;
}
/* 修改历史记录的时间选择器 */
.date-picker {
  width: 100% !important;
  left: 0px !important;
}
/* 修改分页页数选择器 */
.el-select-dropdown__item.selected {
  color: #029fd1;
}
/* 修改消息提示弹框 */
.notifyClass {
  width: 500px;
  padding: 20px;
}
.notifyClass .el-notification__group {
  padding: 0px 20px;
}
.notifyClass .el-notification__icon,
.notifyClass .el-notification__closeBtn {
  font-size: 40px !important;
  line-height: 40px !important;
}
.el-notification__content {
  font-size: 34px !important;
  line-height: 34px !important;
}
.notifyClass .el-notification__title {
  font-size: 40px !important;
  line-height: 40px !important;
}
.custom-message {
  z-index: 9999 !important;
}
/** */
.el-message__content,
.el-message__icon {
  font-size: 28px;
}

.el-message-box {
  width: 75%;
}

.el-select-dropdown {
  max-width: 100%;
}

.el-message-box {
  position: absolute;
  width: 75%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.el-tabs__item {
  color: #000 !important;
}
.el-tabs__item.is-active {
  color: #029fd1 !important;
}
.el-tabs__active-bar {
  background-color: #029fd1 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue